import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { devOpsProviderResource } from '@jira/router-resources__devops-provider/src/devOpsProviderResource.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwareReportsCycleTimeRoute } from '@jira/router-routes__next-gen-routes/src/softwareReportsCycleTimeRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { getTMPReportsCommonResource } from './common/ui/resources/reports/index.tsx';
import { cycleTimeReportPageEntrypoint } from './ui/software/reports/cycle-time-report/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareReportsCycleTimeRouteEntry: Route = createEntry(
	softwareReportsCycleTimeRoute,
	() => ({
		group: 'software',
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getTMPReportsCommonResource(),
			devOpsProviderResource,
		],

		entryPoint: () => {
			if (isDevopsFeatureDisabledInFedRamp()) {
				return notFoundPageEntrypoint;
			}
			return cycleTimeReportPageEntrypoint;
		},

		meta: {
			reporting: {
				id: 'software-reports-cycle-time',
				packageName: camelCase('software-reports-cycle-time'),
				teamName: 'compass-devdogs',
			},
		},

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
